import {HANDLE_PLANS} from "../types/addedPlansTypes";
import {ILunchFormPlan} from "../../Interfaces/IPlans";

export function handleChangePlan(plan:ILunchFormPlan[]) {
  return {
    type: HANDLE_PLANS,
    payload: plan
  };
}
